export default __webpack_public_path__ + "static/media/nestor.19966cb4.jpg";